<template>
  <div id="app" class="app">

    <transition name="fade">
      <div class="loader" v-if="loading || progressBar.enabled">
        <div class="uil-default-css" style="transform:scale(0.7);">
          <div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(0deg) translate(0,-60px);transform:rotate(0deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(30deg) translate(0,-60px);transform:rotate(30deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(60deg) translate(0,-60px);transform:rotate(60deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(90deg) translate(0,-60px);transform:rotate(90deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(120deg) translate(0,-60px);transform:rotate(120deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(150deg) translate(0,-60px);transform:rotate(150deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(180deg) translate(0,-60px);transform:rotate(180deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(210deg) translate(0,-60px);transform:rotate(210deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(240deg) translate(0,-60px);transform:rotate(240deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(270deg) translate(0,-60px);transform:rotate(270deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(300deg) translate(0,-60px);transform:rotate(300deg) translate(0,-60px);border-radius:10px;position:absolute;"></div><div style="top:80px;left:93px;width:14px;height:40px;background:#000000;-webkit-transform:rotate(330deg) translate(0,-60px);transform:rotate(330deg) translate(0,-60px);border-radius:10px;position:absolute;"></div>
        </div>
        <p>{{loadingText}}</p>
        <div class="progress mt-10" v-if="progressBar.enabled">
          <div id="progressBar" class="progress-bar progress-bar-striped active" role="progressbar" :aria-valuenow="progressBar.value" :aria-valuemin="progressBar.min" :aria-valuemax="progressBar.max" :style="{width:progressBar.pourcentage+'%'}"></div>
          <div style="position: absolute;width: 50%;margin:auto;color:black;">
            {{progressBar.txt}}
          </div>
        </div>
      </div>
    </transition>
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="!data || (data && data.session && !data.session.authenticated) || $route.name == 'login' || $route.name == 'quizzes_show'"></router-view>
    <div v-show="(data && data.session && data.session.authenticated) && $route.name != 'login' && $route.name != 'quizzes_show'" class="page-header-fixed page-sidebar-closed-hide-logo page-content-white">

      <!-- BEGIN HEADER -->
      <div class="page-header navbar navbar-fixed-top">
          <!-- BEGIN HEADER INNER -->
          <div class="page-header-inner ">
              <!-- BEGIN LOGO -->
              <div class="page-logo">
                  <router-link :to="{name:'login'}">
                      <img src="./assets/logo_transferh.png" alt="logo" class="logo-default" />
                  </router-link>
                  <div class="menu-toggler sidebar-toggler">
                      <span></span>
                  </div>
              </div>
              <!-- END LOGO -->
              <!-- BEGIN RESPONSIVE MENU TOGGLER -->
              <a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse">
                  <span></span>
              </a>
              <!-- END RESPONSIVE MENU TOGGLER -->
              <!-- BEGIN TOP NAVIGATION MENU -->
              <div class="top-menu">
                  <ul class="nav navbar-nav pull-right">
                      <!-- BEGIN USER LOGIN DROPDOWN -->
                      <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
                      <li class="role_user" v-show="data.user.role == 'dev'">
                        <span class="label label-sm label-success">Développeur</span>
                      </li>
                      <li class="dropdown dropdown-user">
                          <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
                              <!-- <img alt="" class="img-circle" src="./assets/img/avatars/avatar3_small.jpg" /> -->
                              <span class="username username-hide-on-mobile"> {{data.user.firstname}} {{data.user.lastname}} </span>
                              <i class="fa fa-angle-down"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-default">
                              <li>
                                  <router-link :to="{name:'settings'}"><i class="icon-user"></i> Mon compte</router-link>
                              </li>
                              <li class="divider"> </li>
                              <li>
                                  <a v-on:click="logout(true)">
                                      <i class="icon-logout"></i> Se déconnecter
                                  </a>
                              </li>
                          </ul>
                      </li>
                      <!-- END USER LOGIN DROPDOWN -->
                      <!-- BEGIN QUICK SIDEBAR TOGGLER -->
                      <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
                      <li v-on:click="logout(true)" class="dropdown dropdown-quick-sidebar-toggler">
                          <a  class="dropdown-toggle">
                              <i class="icon-logout"></i>
                          </a>
                      </li>
                      <!-- END QUICK SIDEBAR TOGGLER -->
                  </ul>
              </div>
              <!-- END TOP NAVIGATION MENU -->
          </div>
          <!-- END HEADER INNER -->
      </div>
      <!-- END HEADER -->

      <!-- BEGIN HEADER & CONTENT DIVIDER -->
      <div class="clearfix"> </div>
      <!-- END HEADER & CONTENT DIVIDER -->

      <!-- BEGIN CONTAINER -->
      <div class="page-container">
          <!-- BEGIN SIDEBAR -->
          <div class="page-sidebar-wrapper">
              <!-- BEGIN SIDEBAR -->
              <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
              <!-- DOC: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
              <div class="page-sidebar navbar-collapse collapse fixed">
                  <!-- BEGIN SIDEBAR MENU -->
                  <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
                  <!-- DOC: Apply "page-sidebar-menu-hover-submenu" class right after "page-sidebar-menu" to enable hoverable(hover vs accordion) sub menu mode -->
                  <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
                  <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
                  <!-- DOC: Set data-keep-expand="true" to keep the submenues expanded -->
                  <!-- DOC: Set data-auto-speed="200" to adjust the sub menu slide up/down speed -->
                  <ul class="page-sidebar-menu  page-header-fixed" data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200" style="padding-top: 20px">
                      <!-- DOC: To remove the sidebar toggler from the sidebar you just need to completely remove the below "sidebar-toggler-wrapper" LI element -->
                      <!-- BEGIN SIDEBAR TOGGLER BUTTON -->
                      <li class="sidebar-toggler-wrapper hide">
                          <div class="sidebar-toggler">
                              <span></span>
                          </div>
                      </li>
                      <!-- END SIDEBAR TOGGLER BUTTON -->
                      <!-- DOC: To remove the search box from the sidebar you just need to completely remove the below "sidebar-search-wrapper" LI element -->

                      <!-- <li class="nav-item start" :class="{'active': $route.name == 'home','open':$route.name == 'home'}">
                          <router-link :to="{name:'home'}" class="nav-link nav-toggle">
                              <i class="icon-home"></i>
                              <span class="title">Tableau de bord</span>
                              <span class="selected" v-show="{'active': $route.name == 'home','open':$route.name == 'home'}"></span>
                          </router-link>
                      </li> -->
                      <li class="heading">
                          <h3 class="uppercase">Fonctionalités</h3>
                      </li>
                      <li class="nav-item start" :class="{'active': $route.matched[0].name == 'quizzes','open':$route.matched[0].name == 'quizzes'}">
                          <a href="javascript:;" class="nav-link nav-toggle">
                              <i class="icon-note"></i>
                              <span class="title">Questionnaires</span>
                              <span class="arrow open"></span>
                              <span class="selected" v-show="$route.matched[0].name == 'quizzes'"></span>
                          </a>
                          <ul class="sub-menu">
                              <li class="nav-item" :class="{'active': $route.name == 'quizzes_create','open':$route.name == 'quizzes_create'}">
                                  <router-link :to="{name:'quizzes_create'}" :key="$route.fullPath" class="nav-link">
                                      <span class="title">Créer</span>
                                  </router-link>
                              </li>
                              <li class="nav-item" :class="{'active': $route.name == 'quizzes_list','open':$route.name == 'quizzes_list'}">
                                  <router-link :to="{name:'quizzes_list'}" class="nav-link">
                                      <span class="title">Liste</span>
                                  </router-link>
                              </li>
                          </ul>
                      </li>
                      <li class="nav-item" :class="{'active': $route.matched[0].name == 'compare','open':$route.matched[0].name == 'compare'}">
                          <router-link :to="{name:'compare'}" class="nav-link nav-toggle">
                              <i class="icon-pie-chart"></i>
                              <span class="title">Comparaison</span>
                              <span class="selected" v-show="$route.matched[0].name == 'compare'"></span>
                          </router-link>
                      </li>
                      <li v-show="data.user.role == 'dev'" class="nav-item" :class="{'active': $route.matched[0].name == 'users','open':$route.matched[0].name == 'users'}">
                          <a href="javascript:;" class="nav-link nav-toggle">
                              <i class="icon-users"></i>
                              <span class="title">Utilisateurs</span>
                              <span class="arrow open"></span>
                              <span class="selected" v-show="$route.matched[0].name == 'users'"></span>
                          </a>
                          <ul class="sub-menu">
                              <li class="nav-item" :class="{'active': $route.name == 'users_create','open':$route.name == 'users_create'}">
                                <router-link :to="{name:'users_create'}" class="nav-link">
                                    <span class="title">Créer</span>
                                </router-link>
                              </li>
                              <li class="nav-item" :class="{'active': $route.name == 'users_list','open':$route.name == 'users_list'}">
                                <router-link :to="{name:'users_list'}" class="nav-link">
                                    <span class="title">Liste</span>
                                </router-link>
                              </li>
                          </ul>
                      </li>

                      <li class="heading">
                          <h3 class="">Version {{version}}</h3>
                      </li>
                  </ul>
                  <!-- END SIDEBAR MENU -->
                  <!-- END SIDEBAR MENU -->
              </div>
              <!-- END SIDEBAR -->
          </div>
          <!-- END SIDEBAR -->
          <!-- BEGIN CONTENT -->
          <div class="page-content-wrapper">
              <!-- BEGIN CONTENT BODY -->
              <div class="page-content">
                <router-view v-if="$route.name != 'quizzes_show' && $route.name != 'login'"></router-view>
              </div>
              <!-- END CONTENT BODY -->
          </div>
          <!-- END CONTENT -->
      </div>
      <!-- END CONTAINER -->

      <!-- BEGIN FOOTER -->
      <div class="page-footer mt-10">
          <div class="page-footer-inner"> 2017 &copy; TransfeRH &nbsp;|&nbsp;
              Site réalisé par <a target="_blank" href="http://lewebfrancais.fr">Le Web Français</a>
          </div>
          <div class="scroll-to-top">
              <i class="icon-arrow-up"></i>
          </div>
      </div>
      <!-- END FOOTER -->
    </div>

  </div>
</template>

<script>

$.fn.dataTable.moment( 'DD/MM/YYYY' );
import storage from "./storage/data.js";
import Vue from 'vue';
var config = require('./config/settings.json');

export default {
  name: 'app',
  data(){
    return {
      loadingText:"",
      loading: false,
      forceValue:false,
      progressBar:{
        enabled:false,
        min:0,
        max:100,
        value:0,
        txt: "0%",
        pourcentage:0,
      },
      data:storage.data,
      version:config.version
    }
  },
  watch:{
    'data.session.authenticated':function(){
      if(this.data && this.data.session && this.data.session.authenticated !== true){
        if(this.$route.meta && this.$route.meta.requiresAuth){
          // toastr.clear();
          // toastr.error("Votre session a expirée.","ERREUR");
          this.$router.push({name:'login'});
        }
      }
    }
  },
  mounted:function(){
    this.$on("loading",function(value,text,forceValue){
      if(forceValue != null) this.forceValue = forceValue;
      if(this.forceValue){
        this.loading = true;
      }
      else{
        this.loading = value;
      }
      if (text) {
          this.loadingText = text;
      } else {
          this.loadingText = "Chargement en cours...";
      }
    })

    this.$on("progressBar",function(enabled,min,max,val,text){
      this.progressBar.enabled = enabled;
      if (enabled) {
          this.progressBar.min = min;
          this.progressBar.max = max;
          this.progressBar.value = val;
          this.progressBar.txt = text;
          this.progressBar.pourcentage = val*100/max;
      }
      else{
        this.progressBar.pourcentage = 0;
      }
    })

    if(storage && storage.data && storage.data.session && !storage.data.session.authenticated){
      if(this.$route.meta && this.$route.meta.requiresAuth){
        this.logout();
      }
    }
  },
  methods:{
    logout(voluntary){
      if(storage){
        storage.logout();
      }
      if(!voluntary){
        toastr.clear();
        toastr.error("Votre session a expirée.","ERREUR");
        this.$router.push({name:'login'});
      }
    }
  }
}

</script>

<style>

  html,
  body { height: 100%; width: 100%;}

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .app{
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
  }

  .progress{
    width: 50%;
    margin: auto;
    font-weight: bold;
  }

  .loader{
    position: fixed;
    top:0px;
    left:0px;
    background-color: rgba(0,0,0,0.4);
    width:100%;
    height: 100%;
    z-index:10000;
    text-align: center;
    color:white;
  }

  .loader p{
      font-size: 20px;
  }

  .loader .uil-default-css{
    margin-top:40vh;
    margin-left:auto;
    margin-right:auto
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }

  .page-footer .page-footer-inner{
    width: 100%;
    text-align: center;
  }

  .fixed{
    position: fixed;
  }

  .role_user{
    margin-top: 15px;
    margin-right: 20px;
  }

  .logo-default{
    max-width:150px;
    max-height: 40px;
    margin-top:5px!important;
  }

</style>



// WEBPACK FOOTER //
// App.vue?5f5ea1be